import React, { useRef, useState, useEffect } from "react";
import { Dialog, DialogContent, Grid } from "@mui/material";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { TextField, SelectField, FormLabel, MenuItem, Button, Stack, DateField } from "@curves/ui-base";
import { EmployeeSelect } from "@icoach/components/";
import { CONTACT_RESULT_TYPE } from "@icoach/constants/";
import { isEqual, isFunction, refIsRequiredError } from "@util/utils";
import { parseDate } from "@util/moment";
import useContactRecordApi from "@apis/useContactRecordApi";

// 新增聯繫
const NoMemberContactDialog = React.forwardRef((props, ref) => {
	const { open, onClose: onCloseProps, sourceData = {}, refresh: refreshProps } = props;
	if (!open) return null;
	const { peopleID: peopleIDProps, setContractLabelRef } = sourceData;
	const { getCustomerContactRecordOptionsApi, postCustomerContactRecordDataApi } = useContactRecordApi();
	const [options, setOptions] = useState({});
	const [reasonIsRequired, setReasonRequired] = useState(false);
	const contactDateRef = useRef(null);
	const contactReasonTypeRef = useRef(null);
	const contactResultTypeRef = useRef(null);
	const employeeIDRef = useRef(null);
	const notesRef = useRef(null);

	const handleCloseClick = e => onCloseProps && onCloseProps(null);

	const handleAddClick = e => {
		if (!refIsRequiredError(contactDateRef, contactReasonTypeRef, contactResultTypeRef, employeeIDRef, notesRef)) {
			const params = {
				employeeID: employeeIDRef.current.getResult(),
				contactDate: parseDate(contactDateRef.current.getResult()),
				contactResultType: contactResultTypeRef.current.getResult(),
				contactReasonType: contactReasonTypeRef.current.getResult(),
				notes: notesRef.current.getResult(),
			};
			postContactRecordApi(params, peopleIDProps);
		}
	};

	const postContactRecordApi = async (params, targetID) => {
		const resp = await postCustomerContactRecordDataApi(params, targetID);
		if (resp) {
			if (setContractLabelRef && setContractLabelRef.current) {
				setContractLabelRef.current.setContractState(params);
			}
			isFunction(refreshProps) && refreshProps();
            onCloseProps();
		}
	};

	const doInitOptionsApi = async () => {
		const resp = await getCustomerContactRecordOptionsApi();
		resp && setOptions(resp);
	};

	const handleContactResultChange = (e, node) => {
		let isRequired = false;
		// 1 表示 已確認 聯繫內容就為必填 業務需求
		if (isEqual(node.props.value, CONTACT_RESULT_TYPE.CONFIRM)) isRequired = true;
		setReasonRequired(isRequired);
	};

	useEffect(
		() => {
			if (open) doInitOptionsApi();
		},
		// eslint-disable-next-line
		[open],
	);

	const { contactResultTypes: contactResultOption = [], contactReasonTypes: contactReasonOption = [], coaches: employeeOptions = [] } = options;

	return (
		<Dialog open={open} fullWidth>
			<GradientColorHeader onClose={handleCloseClick}>新增聯繫</GradientColorHeader>
			<DialogContent className="mt-3">
				<Grid container spacing={2}>
					<Grid item xs={6}>
						<EmployeeSelect ref={employeeIDRef} options={employeeOptions} label="擔當" fullWidth required />
					</Grid>
					<Grid item xs={6}>
						<DateField ref={contactDateRef} defaultValue={parseDate()} label="聯繫日期" required fullWidth />
					</Grid>
					<Grid item xs={6}>
						<SelectField label="確認電話結果" ref={contactResultTypeRef} onChange={handleContactResultChange} displayEmpty fullWidth required>
							<MenuItem disabled value={""}>
								<em>請選擇</em>
							</MenuItem>
							{contactResultOption.map(({ text, value, disabled }) => (
								<MenuItem value={value} key={value} disabled={disabled}>
									{text}
								</MenuItem>
							))}
						</SelectField>
					</Grid>
					<Grid item xs={6}>
						<SelectField label="聯繫內容" ref={contactReasonTypeRef} displayEmpty fullWidth required={reasonIsRequired}>
							<MenuItem disabled value={""}>
								<em>請選擇</em>
							</MenuItem>
							{contactReasonOption.map(({ text, value, disabled }) => (
								<MenuItem value={value} key={value} disabled={disabled}>
									{text}
								</MenuItem>
							))}
						</SelectField>
					</Grid>
					<Grid item xs={12}>
						<Stack direction="column">
							<FormLabel>聯繫備註</FormLabel>
							<TextField rows={3} multiline ref={notesRef} />
						</Stack>
					</Grid>
					<Grid item xs={12}>
						<Stack justifyContent="end">
							<Button onClick={handleAddClick} variant="contained" color="secondary">
								新增
							</Button>
						</Stack>
					</Grid>
				</Grid>
			</DialogContent>
		</Dialog>
	);
});

export default NoMemberContactDialog;
